<template>
  <div class="login">
    <div class="title">欢迎登录</div>
    <div class="title-sub"><a href="forget.html">忘记密码</a></div>
    <div class="form">
      <div class="item"><input type="text" placeholder="请输入帐号" v-model="account"/></div>
      <div class="item"><input type="password" placeholder="请输入密码" v-model="password"/></div>
      <div class="item"><button class="btn-submit" @click="doLogin">登陆</button><!-- 不可用添加disabled --></div>
    </div>
  </div>
</template>

<script>
    // import api from '../api/api'
    import layer from "layui-layer";

    export default {
      name: 'login',
      data: function(){
        return {
          account: null,
          password: null
        }
      },
      created: function(){
        console.log("login created");
      },
      methods: {
        doLogin: function(){
          console.log("account: " + this.account + ", password: " + this.password)
          this.$http.post('/login/doLogin', this.$data, function (re) {
            if(re.code == '000000'){
              localStorage.setItem("curUserCompany", re.data.name);
              localStorage.setItem("curUserCompanyId", re.data.id);
              window.location.href = 'index.html'
            } else {
              layer.msg(re.message, {fixed: false});
            }
          }, function (re) {
            console.log(re);
          })
        }
      }
    }
</script>
